import Base from './base';

export default class Resizer extends Base {
   _w;
   _h;

   constructor(player, state, options) {
      super(player, state, options);

      this.onResize = this.onResize.bind(this);

      setTimeout(this.onResize);
      this.addEvent(window, 'resize', () => setTimeout(this.onResize) );
      this.bus.on('fullscreenchanged', () => setTimeout(this.onResize, 500) );
      this.bus.on('cclayoutchange', () => setTimeout(this.onResize) );
   }

   onResize() {
      const element = this.player.getElement();

      if (!element) {
         return;
      }

      const $el = element.parentNode ? element.parentNode : element;

      const width = Math.max(element.offsetWidth, $el.offsetWidth);
      const height = Math.max(element.offsetHeight, $el.offsetHeight, $el.parentNode.offsetHeight);
      const outerWidth = Math.max(element.offsetWidth, $el.parentNode.offsetWidth);

      if ( width !== this._w || height !== this._h ) {
         this._h = height;
         this._w = width;
         setTimeout(() => this.bus.emit('resizeplayer', { width, height, outerWidth }));
      }
   }
}
